export const analyzeLine = (point1, point2) => {
  const midpoint = {
    x: (point1.x + point2.x) / 2,
    y: (point1.y + point2.y) / 2
  };
  const slope = (point2.y - point1.y) / (point2.x - point1.x);

  return { midpoint, slope };
};

export const formatLineAnalysis = (analysis) => {
  const { midpoint, slope } = analysis;
  return `Midpoint: (${midpoint.x.toFixed(2)}, ${midpoint.y.toFixed(2)}), Slope: ${slope.toFixed(2)}`;
};